export class FrontendCorporateIdentity {
    primaryColor = "#678fbdff";
    primaryTextColor = "#fff";
    badgeColor = "#e42a7b";
    topbarBgColor = "#58799f";
    topbarBgColorDark = "#3b5471";
    topbarLogoBgColor: string;
    topbarLogoPadding = "0px";
    topbarLogoHeight = "60px";
    loginLogoBackgroundColor: string;
    loginLogoPadding = "0px";
}